export const figure18d = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'Mongolie'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2014','2018','2019']
    },
    labels: {
      	style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 20000,
      tickInterval: 5000,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [4773, 3166, 4315,]
    }, {
      name: 'Autres exploitations',
      data: [12887, 10207, 17257,]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [3554, 2445, 3004,]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [5012, 3322, 4595,]
    }]
  }

  